<template>

    <div class="view">

        <div class="d-flex flex-column flex-grow-1 relative">

            <transition :name="transition">

                <keep-alive >
                    <component v-bind:is="currentView.name" :changeView="changeView" :params="view.params"/>
                </keep-alive>

            </transition>

        </div>
    </div>
</template>

<script>

    import voicemailList from './list.vue';
    import voicemailDetail from './detail.vue';
    import {mapActions, mapState} from "vuex";

    export default {
        name: 'notifications',
        components: {
            'list-view': voicemailList,
            'details-view': voicemailDetail
        },
        data() {
            return {
                visit_id: 0,
                view: {
                    name: 'list-view',
                    params: {}
                },
                transition: 'next'
            }
        },
        methods: {
            ...mapActions('menuRight', ['openMenuRight','closeMenuRight','toggleMenuRight']),
            route(name, transition) {

                this.$router.push({
                    name: name, params: {
                        transition: transition
                    }
                }).catch(err => { console.log('router error: ', err) });
            },
            changeView({view, params}) {
                console.log('ran change view: ', view, params);
                this.view.name = view;
                this.view.params = params || {};

            }
        },
        computed: {
            currentView: function() {

                this.transition = (this.view.name === 'list-view') ? 'prev' : 'next';

                return this.view;
            }
        }
    }

</script>

<style scoped>


</style>
